import type { Y_Tools } from "gql/api";

export function computeYToolLabel(yTool?: Partial<Y_Tools> | null): string {
  if (yTool) {
    const manufacturer = yTool.manufacturer || "";
    const series = yTool.series_model || "";
    if (manufacturer && series) {
      return `${manufacturer} - ${series}`;
    }
    if (manufacturer) {
      return manufacturer;
    }
    if (series) {
      return series;
    }
    return "";
  }
  return "";
}
